import { render, staticRenderFns } from "./CustomCps.vue?vue&type=template&id=0c5e8c91&scoped=true"
import script from "./CustomCps.vue?vue&type=script&lang=js"
export * from "./CustomCps.vue?vue&type=script&lang=js"
import style0 from "./CustomCps.vue?vue&type=style&index=0&id=0c5e8c91&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e8c91",
  null
  
)

export default component.exports